import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { CapyStatsService } from '@shared/services/capystats.service';

/** Where the upgrade CTA was triggered from (NO-PII: a fixed enum, never free text). */
export type UpgradeSource = 'domain-new' | 'domain-settings' | 'positioning';

/**
 * Single entry point for "upgrade your plan" calls-to-action.
 *
 * Routing is centralised here so blocked-feature / quota-exceeded UI across the
 * app (e.g. the content-generator quota banner) can offer a consistent CTA. The
 * plans page is currently a placeholder — payments will be wired in later.
 *
 * Every CTA is also tracked here (one place) so analytics never misses an
 * upgrade intent; callers may pass an optional NO-PII `source` label.
 */
@Injectable({ providedIn: 'root' })
export class UpgradeService {
  private readonly router = inject(Router);
  private readonly capyStats = inject(CapyStatsService);

  /** Navigate to the plans / upgrade page. */
  goToPlans(source?: UpgradeSource): Promise<boolean> {
    // NO-PII: only a fixed enum label, omitted entirely when absent.
    this.capyStats.track(
      'plan_upgrade_cta_clicked',
      source ? { source } : undefined
    );
    return this.router.navigate(['/plans']);
  }
}
